import { render, staticRenderFns } from "./FlowluWidget.vue?vue&type=template&id=80131424&scoped=true"
import script from "./FlowluWidget.vue?vue&type=script&lang=js"
export * from "./FlowluWidget.vue?vue&type=script&lang=js"
import style0 from "./FlowluWidget.vue?vue&type=style&index=0&id=80131424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80131424",
  null
  
)

export default component.exports